module.exports = __webpack_public_path__ + "img/12a.c9cbea8d.png";